import React from 'react';
import { Login } from 'layer7-apihub';

import { AuthenticationLayout } from './AuthenticationLayout';

export const LoginPage = props => {
    return (
        <AuthenticationLayout>
            <Login
                toolbarprops={{
                    button: {
                        variant: 'contained',
                    },
                }}
                openModal={props.location?.openModal}
            />
        </AuthenticationLayout>
    );
};
